/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import { useNavigate } from "react-router-dom";
import useAuth from "../useAuth";
//
import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { BiMenu } from "react-icons/bi";
import { PiFlower } from "react-icons/pi";
import { LogOut, User } from "lucide-react";

const drawerWidth = 240;
const navItems = [];

export default function () {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const handleScrollToElementId = (key) => {};
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{ textAlign: "center" }}
      className="bg-gray-900 h-full"
    >
      <Typography variant="h6" sx={{ my: 2 }} className="text-white">
        <div className="ml-4 flex gap-4 items-center justify-between">
          <div>
            <span className="text-lg flex items-center gap-2 text-blue-400 uppercase font-semibold">
              <b className="text-blue-400">Admin</b>
              <b className="text-green-400">Panel</b>
            </span>
          </div>
        </div>
      </Typography>
      <Divider className="bg-gray-700" />
      <List>
        {navItems?.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton
              sx={{ textAlign: "left" }}
              onClick={() => handleScrollToElementId(item)}
              className="hover:bg-gray-800"
            >
              <div className="flex font-semibold items-center gap-4 text-blue-400">
                <PiFlower className="text-green-400" />
                <div>{item}</div>
              </div>
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* User Info in Mobile Drawer */}
      <div className="absolute bottom-0 w-full p-4 border-t border-gray-700">
        <div className="flex items-center gap-3 mb-3">
          <img
            className="w-10 h-10 rounded-full border-2 border-blue-500 object-cover"
            src="/assets/images/favicon.jpg"
            alt="founder"
          />
          <div className="text-left">
            <p className="text-white text-sm font-medium">
              {user?.fullName || user?.name || "Admin"}
            </p>
            <p className="text-gray-400 text-xs capitalize">
              {user?.userType || "Administrator"}
            </p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 w-full p-2 text-red-400 hover:bg-red-500/10 rounded-lg transition-colors"
        >
          <LogOut size={16} />
          <span className="text-sm">Logout</span>
        </button>
      </div>
    </Box>
  );

  return (
    <div className="bg-gray-900">
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          component="nav"
          sx={{
            bgcolor: "#1f2937", // gray-800
            position: "static",
            boxShadow:
              "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
          }}
        >
          <Toolbar className="!px-4 sm:!px-6">
            {/* Mobile Header */}
            <Box
              color="inherit"
              aria-label="open drawer"
              edge="start"
              sx={{ mr: 2, display: { sm: "none" } }}
              className="flex items-center w-full"
            >
              <IconButton
                onClick={handleDrawerToggle}
                className="!text-white hover:!bg-gray-700"
              >
                <BiMenu className="text-blue-400" />
              </IconButton>
              <div className="ml-4 flex gap-4 items-center w-full justify-between">
                <span className="text-lg text-blue-400 uppercase font-semibold">
                  <b className="text-blue-400">Admin</b>
                  <b className="text-green-400">Panel</b>
                </span>

                <img
                  className="w-10 h-10 rounded-full border-2 object-contain border-blue-500 shadow-lg shadow-blue-500/20"
                  src="/assets/images/favicon.jpg"
                  alt="founder"
                />
              </div>
            </Box>

            {/* Desktop Header */}
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }}
              className="text-white"
            >
              <div className="flex gap-4 items-center justify-between">
                <div className="flex items-start flex-col">
                  <span className="text-lg flex items-center gap-2 text-blue-400 uppercase font-semibold">
                    <p className="text-blue-400">Admin</p>
                    <p className="text-green-400">Panel</p>
                  </span>
                  <span className="text-xs capitalize text-green-400 bg-green-500/10 px-2 py-1 rounded-full mt-1">
                    {user?.userType || "Administrator"}
                  </span>
                </div>

                <div className="flex items-center gap-4">
                  <div className="flex flex-col items-end">
                    <p className="text-white capitalize text-sm font-medium">
                      {user?.fullName || user?.name || "Admin User"}
                    </p>
                    <p className="text-gray-400 text-xs">
                      {user?.email || "admin@example.com"}
                    </p>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => navigate("./profile")}
                      className="p-2 text-gray-400 hover:text-blue-400 hover:bg-gray-700 rounded-lg transition-colors"
                      title="Profile"
                    >
                      <User size={20} />
                    </button>
                    <button
                      onClick={handleLogout}
                      className="p-2 text-gray-400 hover:text-red-400 hover:bg-gray-700 rounded-lg transition-colors"
                      title="Logout"
                    >
                      <LogOut size={20} />
                    </button>
                    <img
                      className="w-12 h-12 rounded-full cursor-pointer border-2 border-blue-500 hover:border-green-400 transition-colors shadow-lg shadow-blue-500/20"
                      src="https://cdn-icons-png.flaticon.com/128/3135/3135715.png"
                      alt="profile"
                      onClick={() => navigate("./profile")}
                    />
                  </div>
                </div>
              </div>
            </Typography>

            {/* Desktop Navigation Items */}
            <Box sx={{ display: { xs: "none", sm: "block" } }}>
              {navItems?.slice(2)?.map((item) => (
                <Button
                  key={item}
                  onClick={() => handleScrollToElementId(item)}
                  className="!text-white hover:!bg-gray-700 !normal-case"
                >
                  <div className="text-blue-400 hover:text-green-400 transition-colors font-semibold">
                    {item}
                  </div>
                </Button>
              ))}
            </Box>
          </Toolbar>
        </AppBar>

        {/* Mobile Drawer */}
        <nav>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: "block", sm: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                backgroundColor: "#111827", // gray-900
                borderRight: "1px solid #374151", // gray-700
              },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </Box>
    </div>
  );
}
